import { isEmpty } from 'lodash'

const openFullScreen = (selector: string) => {
    let elem = document.querySelector(selector)
    // @ts-ignore
    if (elem.requestFullscreen) {
        // @ts-ignore
        elem.requestFullscreen()
    }
    // @ts-ignore
    else if (elem.mozRequestFullScreen) {
        /* Firefox */
        // @ts-ignore
        elem.mozRequestFullScreen()
    }
    // @ts-ignore
    else if (elem.webkitRequestFullscreen) {
        /* Chrome, Safari & Opera */
        // @ts-ignore
        elem.webkitRequestFullscreen()
    }
    // @ts-ignore
    else if (elem.msRequestFullscreen) {
        /* IE/Edge */
        // @ts-ignore
        elem.msRequestFullscreen()
    }
}

const closeFullScreen = () => {
    if (document.exitFullscreen) {
        document.exitFullscreen()
    }
    // @ts-ignore
    else if (document.mozCancelFullScreen) {
        // @ts-ignore
        document.mozCancelFullScreen()
    }
    // @ts-ignore
    else if (document.webkitExitFullscreen) {
        // @ts-ignore
        document.webkitExitFullscreen()
    }
    // @ts-ignore
    else if (document.msExitFullscreen) {
        // @ts-ignore
        document.msExitFullscreen()
    }
}

const isRdmsMaxWindow = () => {
    return window.innerWidth > 1600
}

const getContentSize = (): number => {
    const top = document.getElementsByClassName('pda-title')[0]
    const tab = document.getElementsByClassName('p-tabview-nav-container')[0]
    const search = document.getElementsByClassName('pda-search')[0]

    if (!top) {
        return window.innerHeight
    }

    let bottomSize = 0
    const bottom = document.getElementsByClassName('pda-bottom')
    if (!isEmpty(bottom)) {
        bottomSize = bottom[0].getBoundingClientRect().height - 28
    }
    return (
        window.innerHeight -
        top.getBoundingClientRect().height -
        (tab ? tab.getBoundingClientRect().height + 16 * 1.25 : 0) -
        (search ? search.getBoundingClientRect().height : 0) -
        bottomSize
    )
}

export { isRdmsMaxWindow, getContentSize, openFullScreen, closeFullScreen }
